import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize, LinearProgress, linearProgressClasses, Skeleton, Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../../../../ContextProviders/AppContextProvider';
export const TransactionIndicators = ({ transactionState, loaded }) => {
    const [{ isSmallView }] = useContext(AppMainViewContext);
    return (_jsx(Stack, { direction: isSmallView ? 'column' : 'row', gap: 1, children: Object.entries(transactionState).map(([key, state]) => {
            return (_jsxs(Stack, { flexGrow: 1, gap: 0.5, children: [_jsx(Typography, { variant: "body2", children: capitalize(key) }), loaded ? _jsx(TransactionIndicator, { inProgress: state }) : _jsx(Skeleton, { variant: "rounded", height: '0.25em', width: '100%' })] }, key));
        }) }));
};
const TransactionIndicator = ({ inProgress }) => {
    const [show, setShow] = useState(inProgress);
    useEffect(() => {
        if (inProgress)
            setShow(true);
        else
            setTimeout(() => setShow(false), 1000);
    }, [inProgress]);
    return (_jsxs("div", { style: { display: 'grid' }, children: [_jsx(LinearProgress, { variant: 'determinate', value: 0, color: 'inherit', sx: {
                    gridRowStart: 1,
                    gridColumnStart: 1,
                    ['&::before']: {
                        backgroundColor: (t) => (inProgress ? t.palette.primary.main : t.palette.text.disabled),
                        transition: 'background-color 1s ease-in-out',
                    },
                    [`& .${linearProgressClasses.bar}`]: {
                        display: 'none',
                    },
                } }), show && (_jsx(LinearProgress, { variant: 'indeterminate', color: 'primary', sx: {
                    gridRowStart: 1,
                    gridColumnStart: 1,
                    backgroundColor: 'transparent',
                    opacity: inProgress ? 1 : 0,
                    transition: 'opacity 1s ease-in-out',
                } }))] }));
};
